import { Directive, Injectable } from '@angular/core'

import {
  INFLATION_PROTECTED_BOND,
  NOTE,
  REAL_ESTATE,
} from '../../../constants/constant.content'
import {
  NUMBER_MINUS_ONE,
  NUMBER_TWO,
} from '../../../constants/constant.numbers'
import { CustomDatePipe } from '../../shared/pipe/custom-date.pipe'

@Directive()
@Injectable({
  providedIn: 'root',
})
export class SecYieldService {
  showSecPopupFunds: Array<string> = [
    'REIT',
    'MSF',
    'CHY',
    'GC',
    'TWB',
    'TIB',
    'GNMA',
  ]

  constructor(private readonly customDate: CustomDatePipe) {}

  isPortId(portId: any, portIdList: string | any[]) {
    return portIdList.indexOf(portId) !== NUMBER_MINUS_ONE
  }

  // eslint-disable-next-line complexity
  secYieldLayersFund(fund: any) {
    let yieldLayers = ''
    if (fund) {
      if (this.isPortId(fund.portId, ['3061'])) {
        yieldLayers = 'TWB'
      } else if (this.isPortId(fund.portId, ['0529', '0029'])) {
        yieldLayers = 'CHY'
      } else if (this.isPortId(fund.portId, ['2025', '0525'])) {
        yieldLayers = 'GC'
      } else if (
        this.isPortId(fund.portId, ['2011', '0511', '1231', '1831', '3711'])
      ) {
        yieldLayers = 'TIB'
      } else if (this.isPortId(fund.portId, ['0036', '0536'])) {
        yieldLayers = 'GNMA'
      } else {
        yieldLayers = this.getSecYieldCodeFund(fund, yieldLayers)
      }
    }
    return yieldLayers
  }

  getSecYieldCodeFund(fund: any, yieldLayers: string) {
    if (
      fund.industryCategory &&
      fund.industryCategory.indexOf(INFLATION_PROTECTED_BOND) > NUMBER_MINUS_ONE
    ) {
      yieldLayers = 'MSF'
    } else if (fund.industryCategory && fund.industryCategory === REAL_ESTATE) {
      yieldLayers = 'REIT'
    }
    return yieldLayers
  }

  setRealEsData(yieldsData: any) {
    const secYield: any = {}
    yieldsData.forEach((yieldObj: any) => {
      if (yieldObj.yieldCode === 'ADJYLDREIT') {
        secYield.ADJasOfDate = this.customDate.transform(yieldObj.effectiveDate)
        secYield.reitMthlyAdjEffectiveYld = yieldObj.percent
      } else if (yieldObj.yieldCode === 'UADJYLDRET') {
        secYield.reitMthlyUnadjEffectiveYld = yieldObj.percent
        secYield.secYieldFootNoteCode = NOTE
        secYield.isNote = true
        secYield.showSecPopup = true
      } else {
        if (yieldObj.analytics === undefined) {
          return
        }
        yieldObj.analytics.forEach((distributionAnalyticsObj: any) => {
          const presentYear = new Date().getFullYear()
          if (
            distributionAnalyticsObj.effectiveDate.indexOf(presentYear - 1) !==
            NUMBER_MINUS_ONE
          ) {
            secYield.currentYearReturnOfCapitalAsOfDt =
              distributionAnalyticsObj.effectiveDate.split('-')[0]
            secYield.currentYearReturnOfCapital = distributionAnalyticsObj.value
          }
          if (
            distributionAnalyticsObj.effectiveDate.indexOf(
              presentYear - NUMBER_TWO,
            ) !== NUMBER_MINUS_ONE
          ) {
            secYield.priorYearReturnOfCapitalAsOfDt =
              distributionAnalyticsObj.effectiveDate.split('-')[0]
            secYield.priorYearReturnOfCapital = distributionAnalyticsObj.value
          }
        })
      }
    })
    return secYield
  }

  // eslint-disable-next-line max-statements
  setSecYieldDataForFund(
    fundData: any[],
    caas: any,
    footNoteCodesMap: Map<string, string>,
    yieldsDataReturns: any,
  ) {
    const secYield: any = {}
    // eslint-disable-next-line complexity,max-statements
    fundData.forEach((yieldObj: any) => {
      if (yieldObj.yieldCode === 'SEC') {
        if (yieldObj.timePeriodCode === 'M') {
          secYield.asOfDtM = yieldObj.effectiveDate
          secYield.yieldPctM = yieldObj.percent
          if (yieldObj.footnotes !== undefined) {
            const tempFootNodeArrM = [],
              tempDescriptionsM = []
            yieldObj.footnotes.forEach((obj: any) => {
              tempFootNodeArrM.unshift(obj.code)
              tempDescriptionsM.unshift(obj.description)
              footNoteCodesMap.set(obj.code, obj.description)
            })
            secYield.secYieldFootNoteCodeM = tempFootNodeArrM.join()
            secYield.secHighYieldLayerM = tempDescriptionsM.join()
          }
        } else if (yieldObj.timePeriodCode === 'D') {
          secYield.asOfDtD = yieldObj.effectiveDate
          secYield.yieldPctD = yieldObj.percent
          secYield.secYieldFootNoteCodeD = ''
          secYield.secHighYieldLayeDr = ''
          if (yieldObj.footnotes !== undefined) {
            const tempFootNodeArr = [],
              tempDescriptions = []
            yieldObj.footnotes.forEach((obj: any) => {
              tempFootNodeArr.unshift(obj.code)
              tempDescriptions.unshift(obj.description)
              footNoteCodesMap.set(obj.code, obj.description)
            })
            secYield.secYieldFootNoteCodeD = tempFootNodeArr.join()
            secYield.secHighYieldLayerD = tempDescriptions.join()
          }
        }
        if (
          (yieldObj.methodCode !== null &&
            yieldObj.methodCode === 'SEC-30-M') ||
          yieldObj.methodCode === 'SEC-30-D'
        ) {
          secYield.day = caas.thirtyDay
        } else {
          secYield.day = caas.sevenDay
        }
      }
    })
    if (secYield.asOfDtD) {
      secYield.asOfDt = secYield.asOfDtD
      secYield.yieldPct = secYield.yieldPctD
      secYield.secYieldFootNoteCode = secYield.secYieldFootNoteCodeD
      secYield.secHighYieldLayer = secYield.secHighYieldLayerD
      secYield.secYieldFootNoteCode = secYield.secYieldFootNoteCodeD
      secYield.secHighYieldLayer = secYield.secHighYieldLayerD
      footNoteCodesMap.set(
        secYield.secYieldFootNoteCode,
        secYield.secHighYieldLayer,
      )
    } else {
      secYield.asOfDt = secYield.asOfDtM
      secYield.yieldPct = secYield.yieldPctM
      secYield.secYieldFootNoteCode = secYield.secYieldFootNoteCodeM
      secYield.secHighYieldLayer = secYield.secHighYieldLayerM
      secYield.secYieldFootNoteCode = secYield.secYieldFootNoteCodeM
      secYield.secHighYieldLayer = secYield.secHighYieldLayerM
      footNoteCodesMap.set(
        secYield.secYieldFootNoteCode,
        secYield.secHighYieldLayer,
      )
    }
    secYield.showSecPopup = this.checkFundType(yieldsDataReturns)
    return secYield
  }

  checkFundType(fund: any) {
    if (fund !== undefined) {
      return (
        this.showSecPopupFunds.indexOf(fund.secyieldLayers) > NUMBER_MINUS_ONE
      )
    } else {
      return
    }
  }

  // eslint-disable-next-line complexity,max-statements
  setNotePopupData(fund: any, caas: any, callback: any) {
    const fundObject = {
      fundNameData: '',
      fundCaasData: '',
      fundPolarisData: '',
      notePopupPara: '',
    }
    const aemContent = caas.data.fd3popupsList.items[0]
    const yieldsObj = fund.secYield
    if (fund.secyieldLayers === 'REIT') {
      fundObject.fundNameData = fund.fundName
      this.setREITPopUpData(fundObject, yieldsObj, aemContent)
    } else if (fund.secyieldLayers === 'MSF') {
      fundObject.fundCaasData = aemContent.inflationProtected['html']
      fundObject.notePopupPara = aemContent.inflationProtectedHeader['html']
      fundObject.fundPolarisData = fund.secYield.secHighYieldLayer
    } else if (fund.secyieldLayers === 'CHY') {
      fundObject.fundCaasData = aemContent.highYield['html']
      fundObject.notePopupPara = aemContent.highYieldHeader['html']
      fundObject.fundNameData = fund.fundName
      fundObject.fundPolarisData = fund.secYield.secHighYieldLayer
    } else if (fund.secyieldLayers === 'GC') {
      fundObject.fundCaasData = aemContent.globalCredit['html']
      fundObject.notePopupPara = aemContent.globalCreditHeader['html']
      fundObject.fundNameData = fund.fundName
      fundObject.fundPolarisData = fund.secYield.secHighYieldLayer
    } else if (fund.secyieldLayers === 'TIB') {
      fundObject.fundCaasData = aemContent.totalIntl['html']
      fundObject.notePopupPara = aemContent.totalIntlHeader['html']
      fundObject.fundNameData = fund.fundName
      fundObject.fundPolarisData = fund.secYield.secHighYieldLayer
    } else if (fund.secyieldLayers === 'TWB') {
      fundObject.fundCaasData = aemContent.totalWorld['html']
      fundObject.notePopupPara = aemContent.totalWorldHeader['html']
      fundObject.fundNameData = fund.fundName
      fundObject.fundPolarisData = fund.secYield.secHighYieldLayer
    } else if (fund.secyieldLayers === 'GNMA') {
      fundObject.fundCaasData = aemContent.gnma['html']
      fundObject.notePopupPara = aemContent.gnmaHeader['html']
      fundObject.fundNameData = fund.fundName
      fundObject.fundPolarisData = fund.secYield.secHighYieldLayer
    }
    callback(fundObject)
  }

  // eslint-disable-next-line complexity
  setREITPopUpData(fundObject: any, yieldsObj: any, aemContent: any) {
    fundObject.fundCaasData =
      aemContent.realEstatePara1['plaintext'] +
      ' ' +
      (yieldsObj.reitMthlyUnadjEffectiveYld
        ? parseFloat(yieldsObj.reitMthlyUnadjEffectiveYld).toFixed(NUMBER_TWO) +
          '%'
        : '—') +
      ' ' +
      aemContent.realEstatePara3['plaintext'] +
      ' ' +
      yieldsObj.ADJasOfDate +
      ' ' +
      aemContent.realEstatePara2['plaintext'] +
      ' ' +
      (yieldsObj.reitMthlyAdjEffectiveYld
        ? parseFloat(yieldsObj.reitMthlyAdjEffectiveYld).toFixed(NUMBER_TWO) +
          '%'
        : '—') +
      ' ' +
      aemContent.realEstatePara3['plaintext'] +
      ' ' +
      yieldsObj.ADJasOfDate +
      ' ' +
      aemContent.realEstatePara4['plaintext'] +
      ' ' +
      (yieldsObj.currentYearReturnOfCapital
        ? yieldsObj.currentYearReturnOfCapital.toFixed(NUMBER_TWO) + '%'
        : '—') +
      ' ' +
      aemContent.realEstatePara5['plaintext'] +
      ' ' +
      (yieldsObj.currentYearReturnOfCapitalAsOfDt
        ? yieldsObj.currentYearReturnOfCapitalAsOfDt
        : '—') +
      ' ' +
      aemContent.realEstatePara6['plaintext'] +
      ' ' +
      (yieldsObj.priorYearReturnOfCapital
        ? parseFloat(yieldsObj.priorYearReturnOfCapital).toFixed(NUMBER_TWO) +
          '%'
        : '—') +
      ' ' +
      aemContent.realEstatePara5['plaintext'] +
      ' ' +
      (yieldsObj.priorYearReturnOfCapitalAsOfDt
        ? yieldsObj.priorYearReturnOfCapitalAsOfDt
        : '—') +
      ' ' +
      aemContent.realEstatePara7['plaintext']
  }
}
